module.exports = __webpack_public_path__ + "static/giraffeprintblanket-f6f91328995ed5a3cf111fc366a5797a.jpeg";